export interface SyncHealthSnapshot {
  tenantId: string;
  status: 'idle' | 'error';
  pendingCount: number;
  attentionCount: number;
  consecutiveFailures: number;
  lastError: string | null;
  lastPullAt: string | null;
  lastPushAt: string | null;
}

export interface PreviousSyncHealthReport {
  fingerprint: string;
  emittedAt: number;
}

export function syncHealthFingerprint(snapshot: SyncHealthSnapshot): string {
  return JSON.stringify([
    snapshot.tenantId,
    snapshot.status,
    snapshot.pendingCount,
    snapshot.attentionCount,
    snapshot.consecutiveFailures,
    snapshot.lastError,
  ]);
}

export function shouldEmitSyncHealth(
  previous: PreviousSyncHealthReport | null,
  fingerprint: string,
  now: number,
  periodicReportMs: number,
): boolean {
  return previous === null
    || previous.fingerprint !== fingerprint
    || now - previous.emittedAt >= periodicReportMs;
}
